import React from "react";

const ServiceSkeleton = () => {
  const skeletons = Array(4).fill(0);

  return (
    <div className="bg-[#0bb6d9] py-16 md:px-10 px-6">
      <div className="text-white text-center xl:w-[50%] mx-auto py-10 familjen-font">
        <h1 className="text-lg font-semibold text-white uppercase animate-pulse">
          Loading Services
        </h1>
        <p className="text-white md:text-5xl text-4xl font-semibold capitalize mb-4 animate-pulse">
          Please wait while we <span className="text-black">prepare your results...</span>
        </p>
      </div>

      <div className="flex items-stretch flex-nowrap overflow-x-auto gap-8 snap-x rounded-2xl">
        {skeletons.map((_, index) => (
          <div
            key={index}
            className="bg-white shrink-0 w-full sm:w-[48%] md:w-[45%] lg:w-[30%] xl:w-[23%] snap-center rounded-2xl shadow-md overflow-hidden"
          >
            <div className="h-56 w-full bg-gray-300 animate-pulse"></div>

            <div className="flex justify-center -mt-10">
              <div className="bg-gray-300 p-4 rounded-lg transform rotate-45 w-16 h-16 flex items-center justify-center animate-pulse">
                <div className="-rotate-45">
                  <div className="w-6 h-6 bg-gray-400 rounded-full"></div>
                </div>
              </div>
            </div>

            <div className="md:p-6 p-2 text-center space-y-4">
              <div className="h-6 bg-gray-300 rounded-md w-3/4 mx-auto animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded-md w-5/6 mx-auto animate-pulse"></div>
              <div className="h-4 bg-gray-200 rounded-md w-2/3 mx-auto animate-pulse"></div>
              <div className="h-5 bg-gray-300 rounded-md w-1/3 mx-auto animate-pulse"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceSkeleton;